import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export type FilterBarState = {
  EventBoothsGridPage2: FilterBarPage;
  EventBoothsGridPage: FilterBarPage;
  DiscussionGroups: FilterBarPage;
  EventNetwork: FilterBarPage;
  SidebarMessage: FilterBarPage;
  StageScreenSaver: FilterBarPage & {
    dateFilter: SelectOption;
    trackFilter: SelectOption;
  };
  EventAgendaPage: FilterBarPage & {
    dateFilter: SelectOption;
    trackFilter: SelectOption;
    agendaFavoritesFilter: Boolean;
  };
};

export type FilterBarStateKey = keyof FilterBarState;

export type SelectOption = { value: string; label: string };

export type FilterBarPage = {
  filterTags: string[];
  searchTerm: string;
  sortBy: SelectOption;
  perPage: number;
  currentPage: number;
  loading: boolean;
  totalCount: number;
  failedToLoad: boolean;
  count: number;
  enabledFilters?: boolean;
  hideFilters?: boolean;
};

export const defaultState = (): FilterBarState => ({
  EventBoothsGridPage2: {
    filterTags: [],
    searchTerm: '',
    sortBy: { value: 'recommended', label: 'Default' },
    perPage: 20,
    currentPage: 0,
    loading: true,
    totalCount: 0,
    failedToLoad: false,
    count: 0,
    enabledFilters: false
  },
  EventBoothsGridPage: {
    filterTags: [],
    searchTerm: '',
    sortBy: { value: 'recommended', label: 'Default' },
    perPage: 20,
    currentPage: 0,
    loading: true,
    totalCount: 0,
    failedToLoad: false,
    count: 0,
    enabledFilters: false
  },
  DiscussionGroups: {
    filterTags: [],
    searchTerm: '',
    sortBy: { value: 'recommended', label: 'Default' },
    perPage: 20,
    currentPage: 0,
    loading: true,
    totalCount: 0,
    failedToLoad: false,
    count: 0,
    enabledFilters: false
  },
  SidebarMessage: {
    filterTags: [],
    searchTerm: '',
    sortBy: { value: 'recommended', label: 'Default' },
    perPage: 10,
    currentPage: 0,
    loading: true,
    totalCount: 0,
    failedToLoad: false,
    count: 0,
    enabledFilters: false
  },
  EventNetwork: {
    filterTags: [],
    searchTerm: '',
    sortBy: { value: 'recommended', label: 'Default' },
    perPage: 100,
    currentPage: 0,
    loading: true,
    totalCount: 0,
    failedToLoad: false,
    count: 0,
    enabledFilters: false
  },
  StageScreenSaver: {
    filterTags: [],
    searchTerm: '',
    sortBy: {
      label: 'All',
      value: 'all'
    },
    dateFilter: { value: '', label: '' },
    failedToLoad: false,
    perPage: 20,
    currentPage: 0,
    loading: true,
    totalCount: 0,
    count: 0,
    hideFilters: true,
    trackFilter: { value: 'All', label: 'All' }
  },
  EventAgendaPage: {
    filterTags: [],
    searchTerm: '',
    sortBy: {
      label: 'All',
      value: 'all'
    },
    dateFilter: { value: '', label: '' },
    agendaFavoritesFilter: false,
    failedToLoad: false,
    perPage: 20,
    currentPage: 0,
    loading: true,
    totalCount: 0,
    count: 0,
    trackFilter: { value: '', label: '' },
    hideFilters: true
  }
});

export default {
  state: { ...defaultState() },
  getters,
  actions,
  mutations,
  namespaced: true
};
